import client from "./client";

const getUserById = (id) => {
  return client
    .get(`/users/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};

const getUsers = (filter) => {
  return client
    .get(`/users/paginated`, filter)
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};

const createUser = (data) => {
  return client
    .post("/users", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const deleteUser = (id) => {
  return client
    .delete(`/users/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
};

const updateUser = (data) => {
  return client
    .put(`/users/${data.id}`, data)
    .then((response) => {
      return response;
    }).catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const getMyProfile = () => {
  return client
    .get("/my-profile")
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};

const updateMyProfile = (data) => {
  return client
    .put("/my-profile", data)
    .then((response) => {
      return response;
    }).catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const generateRegisterLink = (companyId) => {
  return client
    .post("/register-links/user", { company_id: companyId })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const validateRegisterToken = (token) => {
  return client
    .post("/register-links/validate/user", { token })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const registerWithToken = (data) => {
  return client
    .post("/register-links/register/user", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const deactivateUser = (id) => {
  return client
    .put(`/users/${id}/deactivate`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
};

const activateUser = (id) => {
  return client
    .put(`/users/${id}/activate`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
};

const userAPI = {
  createUser,
  updateUser,
  deleteUser,
  getUsers,
  getUserById,
  getMyProfile,
  updateMyProfile,
  generateRegisterLink,
  validateRegisterToken,
  registerWithToken,
  deactivateUser,
  activateUser,
};

export default userAPI;
